import { UpsertAssignmentV3Document } from '@/store/v2';
import { FetchResult, useMutation } from '@apollo/client';

import { ASSIGNMENTS_QUERY_OPERATION_NAME } from './constants';
import { AssignmentsV3Result, UpsertAssignmentInput } from './types';

export const useUpsertAssignment = (): {
  upsertAssignmentV3: (input: UpsertAssignmentInput) => Promise<FetchResult<{ upsertAssignmentV3: AssignmentsV3Result }>>;
  loading: boolean;
} => {
  const [upsertAssignmentV3, { loading }] = useMutation<{
    upsertAssignmentV3: AssignmentsV3Result;
  }>(UpsertAssignmentV3Document);

  return {
    upsertAssignmentV3: async (input: UpsertAssignmentInput) =>
      upsertAssignmentV3({
        variables: { input },
        refetchQueries: [ASSIGNMENTS_QUERY_OPERATION_NAME],
      }),
    loading,
  };
};
